import { render } from "./ComplaintDetailDrawer.vue?vue&type=template&id=60d4f3ae&scoped=true"
import script from "./ComplaintDetailDrawer.vue?vue&type=script&lang=js"
export * from "./ComplaintDetailDrawer.vue?vue&type=script&lang=js"

import "./ComplaintDetailDrawer.vue?vue&type=style&index=0&id=60d4f3ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d4f3ae"]])

export default __exports__